export const FROM = 'from';
export const ONBOARDING = 'onboarding';

// GitHub installation URL parameters
export const INSTALLATION_SUCCESS = 'installation_success';
export const INSTALLATION_ID = 'installation_id';
export const INSTALLATION_ERROR = 'installation_error';
export const INSTALLATION_REQUEST = 'installation_request';
export const INSTALLATION_STATUS = 'installation_status';

export const INSTALLATION_STATUS_FAILED = 'failed';
export const INSTALLATION_STATUS_INSTALLED = 'installed';
export const INSTALLATION_STATUS_REQUESTED = 'requested';
